<!--Barra de navegación para usuario de tipo afiliado-->
<template>
  <v-container fluid class="pa-0 ma-0">
    <!-- MENÚ LATERAL PARA PANTALLAS MENORES A UNA TABLETA -->
    <v-navigation-drawer v-model="sidenav" fixed temporary color="primary" dark>
      <v-list dense>
        <v-list-item v-for="item in menuItems" :key="item.title" link :to="item.link">
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- MENÚ PARA PANTALLAS DE MAYOR TAMAÑO -->
    <v-app-bar app dark color="primary" flat height="75">
      <v-toolbar-title class="headline mr-5">
        <v-img src="@/assets/logo-WC-solo.png" width="45px" height="auto"></v-img>
      </v-toolbar-title>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          class="text-capitalize"
          v-for="item in menuItems"
          :key="item.title"
          text
          exact
          :to="item.link"
        >{{ item.title}}</v-btn>
      </v-toolbar-items>
      <v-spacer class="d-none d-md-flex"></v-spacer>
      <v-app-bar-nav-icon @click.native.stop="sidenav = !sidenav" class="d-md-none mr-1"></v-app-bar-nav-icon>
      <v-spacer class="d-flex d-md-none"></v-spacer>
      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-toolbar-items>
            <v-btn class="text-capitalize" text v-on="on">
              Mi cuenta
              <v-icon right small>fas fa-angle-down</v-icon>
            </v-btn>
          </v-toolbar-items>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in submenuItems"
            :key="index"
            :to="item.link"
            class="black--text"
          >
            <v-list-item-icon class="mr-1">
              <v-icon small color="primary">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="userLogout(), () => {}" class="black--text">
            <v-list-item-icon class="mr-1">
              <v-icon small color="primary">fas fa-sign-out-alt</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      sidenav: false,
      menuItems: [
        { title: "Inicio", link: "/" },
        { title: "Eventos", link: "/eventos" },
        //{ title:'Afiliaciones', link:"/afiliaciones" },
        { title: "¿Cómo funciona?", link: "/como-funciona" },
        { title: "Nosotros", link: "/nosotros" }
      ],
      submenuItems: [
        // {
        //   title: "Mis Eventos",
        //   link: "/mis-eventos",
        //   icon: "fas fa-calendar-day"
        // },
        {
          title: "Mis Afiliaciones",
          link: "/mis-afiliaciones",
          icon: "fas fa-crown"
        },
        // {
        //   title: "Método de pagos",
        //   link: "/metodos-de-pago",
        //   icon: "fas fa-credit-card"
        // },
        { title: "Mi perfil", link: "/mi-perfil", icon: "fas fa-user" }
      ]
    };
  },
  methods: {
    ...mapMutations("user", ["logout"]),

    /**
     * Función para cerrar la sesión actual.
     */
    userLogout() {
      this.logout();
      this.$router.push("/login");
    }
  }
};
</script>
<style scoped>
.v-application a {
  color: white;
}
</style>